import { useCallback, useState } from 'react';
import { Form } from 'components';
import { useParams } from 'react-router-dom';
import { StatusType } from 'components/common/StatusBadge';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useTaskByIdQuery, useTaskStatusChangeMutation, useTaskUpdateMutation } from 'api';

export const useGeneral = () => {
  const { id } = useParams() as { id: string };
  const { data: taskDetails = {} } = useTaskByIdQuery({ id });
  const [form] = Form.useForm();
  const { handleError, handleSuccess } = useNotificationMessages();
  const [updateTask] = useTaskUpdateMutation();
  const [changeStatus] = useTaskStatusChangeMutation();
  const [editMode, setEditMode] = useState(false);

  const onUpdate = useCallback(
    async (formData: { description: string; summary: string }) => {
      try {
        const payload = { ...formData, id };
        const { data, error }: any = await updateTask(payload);
        if (data?.success) {
          handleSuccess('The task details were successfully updated.');
          setEditMode(false);
        } else {
          handleError(error);
        }
      } catch (err) {
        console.log(err, 'error');
      }
    },
    [handleSuccess, updateTask, id, handleError]
  );

  const handleStatusChange = useCallback(
    async (status: StatusType) => {
      try {
        const { data, error }: any = await changeStatus({ taskId: id, status });
        if (data?.success) {
          handleSuccess('The task status was successfully changed.');
          setEditMode(false);
        } else {
          handleError(error);
        }
      } catch (err) {
        console.log(err, 'error');
      }
    },
    [handleSuccess, changeStatus, id, handleError]
  );

  return {
    form,
    onUpdate,
    editMode,
    setEditMode,
    taskDetails,
    handleStatusChange,
  };
};
